import { pageRoutes } from 'shared/routes';

import { logError } from './log-errors';
import { showDefaultErrorToast, showSuccessToast } from './notifications';

export enum ShareList {
  INVOICE_CURRENT = 'invoice_current',
  INVOICE_ARCHIVED = 'invoice_archived',
}

const copyToClipboard = async (link: string) => {
  return navigator.clipboard.writeText(link);
};

const getShareLink = (key: string, id: number) => `${window.location.origin}${pageRoutes.app.share}?${key}=${id}`;

export const copyInvoiceLinkToClipboard = async (type: ShareList, id: number) => {
  const link = getShareLink(type, id);

  try {
    await copyToClipboard(link);
    showSuccessToast(`The invoice link has been copied to the clipboard.`);
  } catch (err) {
    logError(err);
    showDefaultErrorToast();
  }
};
